// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `links .nav-link {
  display: flex !important;
}
links .nav-label {
  flex-grow: 1 !important;
}
links .nav-caret {
  flex-shrink: 1 !important;
  color: #aaa !important;
}

.filter-button-alt {
  background-color: #264653 !important;
  border-color: #264653 !important;
}

.only-customer {
  background-color: #c00;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
}

.filterValues {
  position: fixed !important;
  width: 400px !important;
  background-color: #fff !important;
  padding: 10px !important;
  z-index: 1045 !important;
  top: var(--totalHeaderHeight);
  box-shadow: 800px 800px 0px 800px rgba(0, 0, 0, 0.52);
  -webkit-box-shadow: 800px 800px 0px 800px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 800px 800px 0px 800px rgba(0, 0, 0, 0.52);
}

.selected-filter-spacing {
  margin-bottom: 10px;
}

#advert-search-main-panel {
  padding-top: 0 !important;
}

.ghost-result-item {
  width: 100%;
  height: 162px;
  margin-bottom: 16px;
}

#advert-search-nav .nav-link {
  padding: 0 1rem;
}
#advert-search-nav .slim.side-nav {
  width: 3rem !important;
}
#advert-search-nav .side-nav {
  margin-top: var(--totalHeaderHeight) !important;
  height: calc(100% - var(--totalHeaderHeight));
  width: var(--searchMenuWidth) !important;
}

.filterCount {
  color: #aaa !important;
  display: inline-block !important;
  overflow-x: hidden !important;
}

.filterLabel {
  max-width: 310px !important;
  padding-right: 5px !important;
  overflow-x: hidden !important;
  text-overflow: ellipsis !important;
  display: inline-block !important;
  white-space: nowrap !important;
}

.view-results {
  position: sticky !important;
  bottom: 0px !important;
  text-align: center !important;
  width: var(--searchMenuWidth) !important;
  z-index: 9999 !important;
  background-color: #f5f5f5;
  padding-top: 1rem;
}

.group-header {
  background-color: #f4f4f4 !important;
  padding-left: 5px !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.result-count, .results-per-page, .top-row-text {
  display: inline-block !important;
  line-height: 31px;
  font-weight: 400;
  font-size: 0.875rem !important;
}

.selected-items-container {
  display: flex !important;
  padding-right: 10px !important;
  padding-left: 16px !important;
}
.selected-items-container .chosen-items {
  flex-grow: 1 !important;
  font-size: 10px !important;
  padding-right: 5px !important;
  font-weight: 500 !important;
  padding-left: 7px;
  line-height: 18px;
}
.selected-items-container .reset-filter-box {
  flex-shrink: 1 !important;
  color: #f66 !important;
  opacity: 0.8 !important;
  cursor: pointer !important;
}
.selected-items-container .reset-filter-inline {
  float: right !important;
  display: inline-block;
  font-size: 12px;
}

.filter-label {
  font-size: 0.875rem;
  font-weight: 500;
  padding-bottom: 5px;
}

.side-nav .nav-item .nav-link {
  border-top: 1px solid #eee;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.selected-item {
  cursor: pointer !important;
  line-height: 20px;
}
.selected-item:hover {
  background-color: rgba(50, 50, 50, 0.1);
}
.selected-item .fa-times-circle:before {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: inset 0 0 0 2px #c00;
  box-sizing: border-box;
  height: 12px;
  width: 12px;
  font-size: 12px;
  line-height: 12px;
  color: #c00 !important;
}

.view-results button {
  margin-bottom: 10px;
}
.view-results .result-count button {
  font-size: 16px;
}
.view-results .clear-filters button {
  font-size: 12px;
  opacity: 0.6;
}
.view-results .clear-filters button:hover {
  opacity: 1;
}

.paginator ul {
  padding-inline-start: 0 !important;
  margin-bottom: 0 !important;
}

.btn-group .btn {
  border-color: var(--linkColour);
  font-weight: 400;
}
.btn-group .btn.active {
  background-color: var(--linkColour);
  color: #fff;
}

.top-row-select, .bottom-row-select {
  margin-bottom: 0.5rem;
}
.top-row-select .input-group-text, .bottom-row-select .input-group-text {
  padding: 0.15rem 0.5rem !important;
  font-size: 0.875rem !important;
}
.top-row-select mdb-select.mdb-select-outline .single, .bottom-row-select mdb-select.mdb-select-outline .single {
  padding: 0.15rem 0 !important;
  border: 1px solid var(--softInputBorderColour) !important;
}
.top-row-select mdb-select.mdb-select-outline .single .value, .bottom-row-select mdb-select.mdb-select-outline .single .value {
  font-size: 0.875rem !important;
}
.top-row-select .mdb-select-toggle, .bottom-row-select .mdb-select-toggle {
  line-height: 1.7rem;
  width: 26px !important;
}
.top-row-select .mdb-select-toggle:before, .bottom-row-select .mdb-select-toggle:before {
  width: 26px !important;
}

.disabled-filter, .disabled {
  pointer-events: none;
  opacity: 0.6;
}

@media (min-width: 1200px) {
  #advert-search-main-panel {
    padding-left: calc(var(--searchMenuWidth)) !important;
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }
}
@media (max-width: 765px) {
  #advert-search-nav .side-nav {
    margin-top: var(--headerHeight) !important;
  }
}
@media (max-width: 575px) {
  .filterValues {
    left: 0px !important;
    width: 100% !important;
    box-shadow: 0px 0px 10px 0px #000000;
  }
}
@media (min-width: 576px) {
  .filterValues {
    left: calc(var(--searchMenuWidth) + 1px);
  }
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/advert/advert-search/advert-search.component.scss"],"names":[],"mappings":"AAGE;EACE,wBAAA;AAFJ;AAKE;EACE,uBAAA;AAHJ;AAME;EACE,yBAAA;EACA,sBAAA;AAJJ;;AAQA;EAEE,oCAAA;EACA,gCAAA;AANF;;AAUA;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAPF;;AAUA;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,wBAAA;EACA,wBAAA;EACA,6BAAA;EACA,qDAAA;EACA,6DAAA;EACA,0DAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EAEE,yBAAA;AARF;;AAYA;EAEE,WAAA;EACA,aAAA;EACA,mBAAA;AAVF;;AAeE;EACE,eAAA;AAZJ;AAeE;EACE,sBAAA;AAbJ;AAgBE;EACE,+CAAA;EACA,6CAAA;EACA,wCAAA;AAdJ;;AAkBA;EACE,sBAAA;EACA,gCAAA;EACA,6BAAA;AAfF;;AAkBA;EACE,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,kCAAA;EACA,gCAAA;EACA,8BAAA;AAfF;;AAkBA;EACE,2BAAA;EACA,sBAAA;EACA,6BAAA;EACA,wCAAA;EACA,wBAAA;EACA,yBAAA;EACA,iBAAA;AAfF;;AAkBA;EAEE,oCAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;AAhBF;;AAoBA;EAEE,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AAlBF;;AAsBA;EACE,wBAAA;EACA,8BAAA;EACA,6BAAA;AAnBF;AAqBE;EACE,uBAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,iBAAA;EACA,iBAAA;AAnBJ;AAsBE;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;AApBJ;AAuBE;EACE,uBAAA;EACA,qBAAA;EACA,eAAA;AArBJ;;AA0BA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;AAvBF;;AA0BA;EAEE,0BAAA;EACA,iBAAA;AAxBF;AA0BE;EACE,uCAAA;AAxBJ;AA2BE;EACE,sBAAA;EACA,kBAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAzBJ;;AA+BE;EACE,mBAAA;AA5BJ;AA+BE;EAEE,eAAA;AA9BJ;AAiCE;EAEE,eAAA;EACA,YAAA;AAhCJ;AAkCI;EACE,UAAA;AAhCN;;AAuCE;EACE,kCAAA;EACA,2BAAA;AApCJ;;AAwCA;EAEE,+BAAA;EACA,gBAAA;AAtCF;AAwCE;EACE,mCAAA;EACA,WAAA;AAtCJ;;AA0CA;EAEE,qBAAA;AAxCF;AA0CE;EACE,kCAAA;EACA,8BAAA;AAxCJ;AA2CE;EACE,6BAAA;EAMA,yDAAA;AA9CJ;AA0CI;EACE,8BAAA;AAxCN;AA8CE;EACE,mBAAA;EACA,sBAAA;AA5CJ;AA8CI;EACE,sBAAA;AA5CN;;AAkDA;EACE,oBAAA;EACA,YAAA;AA/CF;;AAkDA;EAEE;IAEE,qDAAA;IACA,8BAAA;IACA,+BAAA;EAjDF;AACF;AAsDA;EACE;IAA+B,0CAAA;EAnD/B;AACF;AAqDA;EAGE;IACE,oBAAA;IACA,sBAAA;IACA,oCAAA;EArDF;AACF;AAuDA;EACE;IACE,wCAAA;EArDF;AACF","sourcesContent":["\nlinks {\n\n  .nav-link {\n    display: flex !important;\n  }\n\n  .nav-label {\n    flex-grow: 1 !important;\n  }\n\n  .nav-caret {\n    flex-shrink: 1 !important;\n    color: #aaa !important;\n  }\n}\n\n.filter-button-alt {\n\n  background-color: #264653 !important;\n  border-color: #264653 !important;\n\n}\n\n.only-customer {\n  background-color: #c00;\n  color: #fff;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.filterValues {\n  position: fixed !important;\n  width: 400px !important;\n  background-color: #fff !important;\n  padding: 10px !important;\n  z-index: 1045 !important;\n  top: var(--totalHeaderHeight);\n  box-shadow: 800px 800px 0px 800px rgba(0, 0, 0, 0.52);\n  -webkit-box-shadow: 800px 800px 0px 800px rgba(0, 0, 0, 0.52);\n  -moz-box-shadow: 800px 800px 0px 800px rgba(0, 0, 0, 0.52);\n}\n\n.selected-filter-spacing {\n  margin-bottom: 10px;\n}\n\n#advert-search-main-panel {\n\n  padding-top: 0 !important;\n\n}\n\n.ghost-result-item {\n\n  width: 100%;\n  height: 162px;\n  margin-bottom: 16px;\n}\n\n#advert-search-nav {\n\n  .nav-link {\n    padding: 0 1rem;\n  }\n\n  .slim.side-nav {\n    width: 3rem !important;\n  }\n\n  .side-nav {\n    margin-top: var(--totalHeaderHeight) !important;\n    height: calc(100% - var(--totalHeaderHeight));\n    width: var(--searchMenuWidth) !important;\n  }\n}\n\n.filterCount {\n  color: #aaa !important;\n  display: inline-block !important;\n  overflow-x: hidden !important;\n}\n\n.filterLabel {\n  max-width: 310px !important;\n  padding-right: 5px !important;\n  overflow-x: hidden !important;\n  text-overflow: ellipsis !important;\n  display: inline-block !important;\n  white-space: nowrap !important;\n}\n\n.view-results {\n  position: sticky !important;\n  bottom: 0px !important;\n  text-align: center !important;\n  width: var(--searchMenuWidth) !important;\n  z-index: 9999 !important;\n  background-color: #f5f5f5;\n  padding-top: 1rem;\n}\n\n.group-header {\n\n  background-color: #f4f4f4 !important;\n  padding-left: 5px !important;\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n  padding-top: 3px !important;\n  padding-bottom: 3px !important;\n\n}\n\n.result-count, .results-per-page, .top-row-text {\n\n  display: inline-block !important;\n  line-height: 31px;\n  font-weight: 400;\n  font-size: 0.875rem !important\n\n}\n\n.selected-items-container {\n  display: flex !important;\n  padding-right: 10px !important;\n  padding-left: 16px !important;\n\n  .chosen-items {\n    flex-grow: 1 !important;\n    font-size: 10px !important;\n    padding-right: 5px !important;\n    font-weight: 500 !important;\n    padding-left: 7px;\n    line-height: 18px;\n  }\n\n  .reset-filter-box {\n    flex-shrink: 1 !important;\n    color: #f66 !important;\n    opacity: 0.8 !important;\n    cursor: pointer !important;\n  }\n\n  .reset-filter-inline {\n    float: right !important;\n    display: inline-block;\n    font-size: 12px;\n  }\n\n}\n\n.filter-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding-bottom: 5px;\n}\n\n.side-nav .nav-item .nav-link {\n  border-top: 1px solid #eee;\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n\n.selected-item {\n\n  cursor: pointer !important;\n  line-height: 20px;\n\n  &:hover {\n    background-color: rgba(50, 50, 50, 0.1);\n  }\n\n  .fa-times-circle:before {\n    background-color: #fff;\n    border-radius: 6px;\n    box-shadow: inset 0 0 0 2px #c00;\n    box-sizing: border-box;\n    height: 12px;\n    width: 12px;\n    font-size: 12px;\n    line-height: 12px;\n    color: #c00 !important;\n  }\n}\n\n.view-results {\n\n  button {\n    margin-bottom: 10px;\n  }\n\n  .result-count button {\n\n    font-size: 16px;\n  }\n\n  .clear-filters button {\n\n    font-size: 12px;\n    opacity: 0.6;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.paginator {\n\n  ul {\n    padding-inline-start: 0 !important;\n    margin-bottom: 0 !important;\n  }\n}\n\n.btn-group .btn {\n\n  border-color: var(--linkColour);\n  font-weight: 400;\n\n  &.active {\n    background-color: var(--linkColour);\n    color: #fff;\n  }\n}\n\n.top-row-select, .bottom-row-select {\n\n  margin-bottom: 0.5rem;\n\n  .input-group-text {\n    padding: 0.15rem 0.5rem !important;\n    font-size: 0.875rem !important;\n  }\n\n  mdb-select.mdb-select-outline .single {\n    padding: 0.15rem 0 !important;\n\n    .value {\n      font-size: 0.875rem !important;\n    }\n\n    border: 1px solid var(--softInputBorderColour) !important;\n  }\n\n  .mdb-select-toggle {\n    line-height: 1.7rem;\n    width: 26px !important;\n\n    &:before {\n      width: 26px !important;\n    }\n  }\n\n}\n\n.disabled-filter, .disabled {\n  pointer-events:none; //This makes it not clickable\n  opacity:0.6;         //This grays it out to look disabled\n}\n\n@media (min-width: 1200px) {\n\n  #advert-search-main-panel {\n\n    padding-left: calc(var(--searchMenuWidth)) !important;\n    margin-left: 1.5rem !important;\n    margin-right: 1.5rem !important;\n\n  }\n\n}\n\n@media (max-width: 765px) {\n  #advert-search-nav .side-nav { margin-top: var(--headerHeight) !important; }\n}\n\n@media (max-width: 575px) {\n\n\n  .filterValues {\n    left: 0px !important;\n    width: 100% !important;\n    box-shadow: 0px 0px 10px 0px #000000;\n  }\n}\n@media (min-width: 576px) {\n  .filterValues {\n    left: calc(var(--searchMenuWidth) + 1px);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
